export default __webpack_public_path__ + "static/media/ic-leaves.81c3c54a.svg";